import React, { Component } from "react";
import { connect } from "react-redux";
import { Button, Table } from "semantic-ui-react";
import { getTranslate } from "react-localize-redux";
import { getProducts } from "../../../../reducer";


class ProductsTable extends Component {
    render() {
        return (
            <Table celled>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell>{this.props.translate("inventory.table.header.code")}</Table.HeaderCell>
                        <Table.HeaderCell>{this.props.translate("inventory.table.header.size")}</Table.HeaderCell>
                        <Table.HeaderCell>{this.props.translate("inventory.table.header.vintage")}</Table.HeaderCell>
                        <Table.HeaderCell>{this.props.translate("inventory.table.header.box")}</Table.HeaderCell>
                        <Table.HeaderCell>Select</Table.HeaderCell>
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    {this.props.products.sort((a, b) => {
                        if (typeof a.variations[0] === "undefined") {
                            return 1;
                        }

                        if (typeof b.variations[0] === "undefined") {
                            return -1;
                        }

                        return Number.parseInt(a.variations[0].code, 10) - Number.parseInt(b.variations[0].code, 10) === 0 ?
                            Number.parseInt(a.variations[1].code, 10) - Number.parseInt(b.variations[1].code, 10) :
                            Number.parseInt(a.variations[0].code, 10) - Number.parseInt(b.variations[0].code, 10);
                    })
                        .map((product) =>
                            <Table.Row
                                key={product.id}>
                                <Table.Cell>{product.code}</Table.Cell>
                                <Table.Cell>{(this.props.noMatrix || typeof product.variations === "undefined" || typeof product.variations[0] === "undefined") ? "-" : product.variations[0].code}</Table.Cell>
                                <Table.Cell>{(this.props.noMatrix || typeof product.variations === "undefined" || typeof product.variations[1] === "undefined") ? "-" : product.variations[1].code}</Table.Cell>
                                <Table.Cell>{(this.props.noMatrix || typeof product.variations === "undefined" || typeof product.variations[2] === "undefined") ? "-" : product.variations[2].code}</Table.Cell>
                                <Table.Cell>
                                    <Button onClick={() => {
                                        this.props.productSelected(product);
                                    }}>Duplicate</Button>
                                    <Button onClick={() => {
                                        this.props.productSelectedForEdit(product);
                                    }}>Edit</Button>
                                </Table.Cell>
                            </Table.Row>
                        )}
                </Table.Body>
            </Table>
        );
    }
}

const mapStateToProps = state => ({
    translate: getTranslate(state.localize),
    products: getProducts(state.tools),
});


const mapDispatchToProps = (dispatch) => {
    return ({});
};


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ProductsTable);



// WEBPACK FOOTER //
// ./src/scenes/Tools/scenes/ManageProducts/components/ProductsTable/index.js